export default __webpack_public_path__ + "static/media/non-goldbuild.274c3dee.svg";